import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-javascript-icon',
  templateUrl: './documents-javascript.component.html'
})
export class DocumentsJavascriptComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
